export const Role = {
    User: 1
}